import { render } from "./UserFollowersFollowing.vue?vue&type=template&id=634631b0&scoped=true"
import script from "./UserFollowersFollowing.vue?vue&type=script&lang=js"
export * from "./UserFollowersFollowing.vue?vue&type=script&lang=js"

import "./UserFollowersFollowing.vue?vue&type=style&index=0&id=634631b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634631b0"]])

export default __exports__